import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { Field, FieldProps, Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { RouterLink } from '../../../../components/Link';
import { TextField } from '../../../../components/TextField';
import type { OnSubmit } from '../../../../design-system';
import { createSchema } from '../../../../utils/formUtils';

type RequestNewCodeFormFields = { email: string };

const initialValues: RequestNewCodeFormFields = { email: '' };

const validationSchema = createSchema<RequestNewCodeFormFields>({
  email: Yup.string().email('Email must be a valid email address').required('Email is required'),
});

export interface RequestNewCodeFormProps {
  onSubmit: OnSubmit<RequestNewCodeFormFields>;
}

export const RequestNewCodeForm: React.FC<RequestNewCodeFormProps> = ({ onSubmit }) => (
  <Fade in>
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, helpers) => onSubmit({ ...values, email: values.email.toLowerCase() }, helpers)}
        validateOnBlur={false}
        validateOnChange={false}
      >
        {({ errors, isSubmitting }) => (
          <Form>
            <Box textAlign="center">
              <Typography>Enter your email to request a new verification code.</Typography>
            </Box>
            <Box mt={3}>
              <Field name="email">
                {({ field: { onBlur, onChange, name, value } }: FieldProps<RequestNewCodeFormFields['email']>) => (
                  <TextField
                    autoFocus
                    disabled={isSubmitting}
                    error={!!errors.email}
                    fullWidth
                    helperText={errors.email}
                    label="Email"
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    size="medium"
                    type="email"
                    value={value}
                  />
                )}
              </Field>
            </Box>
            <Box mt={3}>
              <Button color="primary" disabled={isSubmitting} fullWidth size="large" type="submit" variant="contained">
                {isSubmitting ? <CircularProgress size={26} color="inherit" /> : 'Request code'}
              </Button>
            </Box>
            <Box mt={2} textAlign="center">
              <RouterLink to="/auth/signin">Go to sign in screen</RouterLink>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  </Fade>
);
